import { Directive, ElementRef, Input, NgZone, OnInit, HostListener } from '@angular/core';

@Directive({
  selector: '[magic]'
})
@HostListener('window:resize', ['$event'])
export class MagicDirective implements OnInit {
  @Input() type?: string;
  @Input() conf?: any;
  @Input() magicCss?: any;
  css = '';
  constructor(
    private el: ElementRef,
    private ngZone: NgZone
  ) {
    window.onresize = (e) => {
      console.log("Resized: " + window.innerWidth);
      this.launcher();
      this.ngZone.run(() => {
        //console.log("Resized: " + window.innerWidth);
        //this.launcher();
      });
    };
  }

  ngOnInit() {
    this.launcher();
  }
  addCss(newCss: string) {
    this.css += newCss + ';';
  }

  launcher() {
    this.css="";
    switch (this.magicCss.type) {
      case 'thumb':
        this.thumb();
        break;
      case 'square':
        this.square();
        break;
      case 'rectangle':
        this.rectangle();
        break;
      case 'rectanglex2':
        this.rectanglex2();
        break;
      case 'fullheight':
        this.fullheight();
        break;
      case 'heightEqualTo':
        this.heightEqualTo();
        break;
      /*** Custom ***/
      case 'banner':
        this.customBanner();
        break;
      case 'burbankCard':
        this.burbankCard();
        break;
    }
  }

  /***** WWF CUSTOM DIRECTIVES *****/
  burbankCard() {
    setTimeout(() => {
      this.addCss('height: ' + (this.el.nativeElement.offsetWidth * 1.5) + 'px !important;');
      if (this.magicCss.background) {
        this.addCss('background: url(' + this.magicCss.background + ') center !important;');
        this.addCss('background-size: cover !important;');
        this.addCss('background-repeat: no-repeat !important;');
      }
      this.el.nativeElement.setAttribute('style', this.css)
    }, 350);
  }
  customBanner() {
    setTimeout(() => {
      if (window.innerWidth <= 960) {
        this.addCss('height: ' + (this.el.nativeElement.offsetWidth * 0.75) + 'px !important;');
      }
      else {
        this.addCss('height: ' + (this.el.nativeElement.offsetWidth * 0.33) + 'px !important;');
      }
      if (this.magicCss.background) {
        this.addCss('background: url(' + this.magicCss.background + ') center !important;');
        this.addCss('background-size: cover !important');
      }
      this.el.nativeElement.setAttribute('style', this.css)
    }, 400);
  }
  /***** GENERIC DIRECTIVES *****/
  fullheight() {
    this.addCss('height: ' + (window.innerHeight - 80) + 'px !important;');
    if (this.magicCss.background) {
      this.addCss('background: url(' + this.magicCss.background + ') center !important;');
      this.addCss('background-size: cover !important;');
    }
    this.el.nativeElement.setAttribute('style', this.css)
  }
  thumb() {
    setTimeout(() => {
      this.addCss('height: ' + (this.el.nativeElement.offsetWidth) + 'px !important;');
      if (this.magicCss.background) {
        this.addCss('background: url(' + this.magicCss.background + ') center !important;');
        this.addCss('background-size: contain !important');
        this.addCss('background-position: center !important');
        this.addCss('background-repeat: no-repeat !important');
      }
      this.el.nativeElement.setAttribute('style', this.css)
    }, 350);
  }
  square() {
    setTimeout(() => {
      this.addCss('height: ' + (this.el.nativeElement.offsetWidth) + 'px !important;');
      this.addCss('max-height: ' + (this.el.nativeElement.offsetWidth) + 'px !important;');
      this.addCss('overflow: hidden');
      if (this.magicCss.background) {
        this.addCss('background: url(' + this.magicCss.background + ') center !important;');
        this.addCss('background-size: cover !important');
      }
      this.el.nativeElement.setAttribute('style', this.css);
    }, 1000);
  }
  rectangle() {
    setTimeout(() => {
      this.addCss('height: ' + (this.el.nativeElement.offsetWidth * 0.625) + 'px !important;');
      this.addCss('min-height: ' + (this.el.nativeElement.offsetWidth * 0.625) + 'px !important;');
      if (this.magicCss.background) {
        this.addCss('background: url(' + this.magicCss.background + ') center !important;');
        this.addCss('background-size: cover !important');
      }
      this.el.nativeElement.setAttribute('style', this.css)
    }, 350);
  }
  rectanglex2() {
    setTimeout(() => {
      this.addCss('height: ' + (this.el.nativeElement.offsetWidth/4) + 'px !important;');
      if (this.magicCss.background) {
        this.addCss('background: url(' + this.magicCss.background + ') center !important;');
        this.addCss('background-size: cover !important');
      }
      this.el.nativeElement.setAttribute('style', this.css)
    }, 350);
  }
  heightEqualTo() {
    setTimeout(() => {
      if (this.magicCss.targetclass) {
        let temp = 0;
        let domElements = document.getElementsByClassName(this.magicCss.targetclass);
        for (var i = 0; i < domElements.length; i++) {
          let x = <HTMLElement><unknown>domElements[i];
          if (temp < x.offsetHeight) {
            temp = x.offsetHeight;
          }
        }
        this.addCss('height: ' + (temp) + 'px !important;');
      }
      /* if (this.magicCss.background) {
        this.addCss('background: url(' + this.magicCss.background + ') center !important;');
        this.addCss('background-size: cover !important');
      } */
      this.el.nativeElement.setAttribute('style', this.css)
    }, 500);
  }

}
